<div class="flex flex-center">
    <div class="flex flex-fill">
        <span>{{message}}</span>
    </div>
    <button mat-stroked-button (click)="saveClick()" [disabled]="saveDisabled">Speichern</button>
    <button mat-stroked-button (click)="cancelClick()">Abbrechen</button>
</div>